"use strict";

export const FlingNativeProperties = new Set(['direction', 'numberOfPointers']);
//# sourceMappingURL=FlingTypes.js.map